import React from "react"; // optional if you're using a recent compiler that supports automatic JSX run
import {
  FormatBold,
  FormatItalic,
  FormatUnderlined,
  FormatStrikethrough,
  Superscript,
  Subscript,
  Code,
  FormatAlignLeft,
  FormatAlignCenter,
  FormatAlignRight,
  FormatAlignJustify,
  HorizontalRule,
  FormatListBulleted,
  FormatListNumbered,
  InsertLink,
  Refresh,
  Replay,
  CreateOutlined,
  FormatQuote,
  TableChart,
  Image,
  FormatColorFill,
  FormatColorText,
  CheckBox,
  Tag,
  TextIncrease,
  TextDecrease,
} from "@mui/icons-material";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import ContentCutIcon from "@mui/icons-material/ContentCut";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import FormatIndentIncreaseIcon from "@mui/icons-material/FormatIndentIncrease";
import FormatIndentDecreaseIcon from "@mui/icons-material/FormatIndentDecrease";
import FormatClearIcon from "@mui/icons-material/FormatClear";
import QrCodeIcon from "@mui/icons-material/QrCode";
import StrikethroughSIcon from '@mui/icons-material/StrikethroughS';
export enum RichTextAction {
  Bold = "bold",
  Italic = "italic",
  Underline = "underline",
  Strikethrough = "strikethrough",
  Superscript = "superscript",
  Subscript = "subscript",
  Highlight = "highlight",
  Code = "code",
  LeftAlign = "leftAlign",
  CenterAlign = "centerAlign",
  RightAlign = "rightAlign",
  JustifyAlign = "justifyAlign",
  Divider = "divider",
  OrderList = "orderedList",
  UnOrderList = "unorderedList",
  CheckList = "checkList",
  Link = "formatInsertLink",
  Undo = "undo",
  Redo = "redo",
  Quote = "quote",
  Table = "insertTable",
  Image = "insertImage",
  TextColor = "textColor",
  BackgroundColor = "backgroundColor",
  FontSize = "fontSize",
  FontFamily = "fontFamily",
  HorizontalRule = "horizontalRule",
  ColorPicker = "colorPicker",
  BackgroundColorPicker = "backgroundColorPicker",
  Cut = "cut",
  Copy = "copy",
  Paste = "paste",
  IncreaseIndent = "increaseIndent",
  DecreaseIndent = "decreaseIndent",
  ClearFormat = "clearFormat",
}

export const RICH_TEXT_OPTIONS = [
  {
    id: RichTextAction.Undo,
    icon: <Replay />,
    label: "Undo",
  },
  {
    id: RichTextAction.Redo,
    icon: <Refresh />,
    label: "Redo",
  },
  {
    id: RichTextAction.Cut,
    icon: <ContentCutIcon fontSize="small" />,
    label: "Cut",
  },
  {
    id: RichTextAction.Copy,
    icon: <ContentCopyIcon fontSize="small" />,
    label: "Copy",
  },
  {
    id: RichTextAction.Paste,
    icon: <ContentPasteIcon fontSize="small" />,
    label: "Paste",
  },
  // { id: RichTextAction.Divider, icon: <HorizontalRule /> },
  { id: RichTextAction.Bold, icon: <FormatBold />, label: "Bold" },
  { id: RichTextAction.Italic, icon: <FormatItalic />, label: "Italic" },
  {
    id: RichTextAction.Underline,
    icon: <FormatUnderlined />,
    label: "Underline",
  },
  // {
  //   id: RichTextAction.Strikethrough,
  //   icon: <FormatStrikethrough />,
  //   label: "Strikethrough",
  // },
  // {
  //   id: RichTextAction.Superscript,
  //   icon: <Superscript />,
  //   label: "Superscript",
  // },
  // {
  //   id: RichTextAction.Subscript,
  //   icon: <Subscript />,
  //   label: "Subscript",
  // },
  // {
  //   id: RichTextAction.Highlight,
  //   icon: <CreateOutlined />,
  //   label: "Highlight",
  // },

  // { id: RichTextAction.Divider, icon: <HorizontalRule /> },
  // {
  //   id: RichTextAction.TextColor,
  //   icon: <FormatColorText />,
  //   label: "Text Color",
  // },
  // {
  //   id: RichTextAction.BackgroundColor,
  //   icon: <FormatColorFill />,
  //   label: "Background Color",
  // },
  // { id: RichTextAction.Divider, icon: <HorizontalRule /> },
  { id: RichTextAction.ColorPicker, icon: <HorizontalRule /> },
  { id: RichTextAction.BackgroundColorPicker, icon: <HorizontalRule /> },
  // { id: RichTextAction.Divider, icon: <HorizontalRule /> },
  {
    id: RichTextAction.OrderList,
    icon: <FormatListNumbered />,
    label: "Ordered List",
  },
  {
    id: RichTextAction.UnOrderList,
    icon: <FormatListBulleted />,
    label: "Unordered List",
  },
  // {
  //   id: RichTextAction.CheckList,
  //   icon: <CheckBox />,
  //   label: "Check List",
  // },
  // { id: RichTextAction.Divider, icon: <HorizontalRule /> },

  // {
  //   id: RichTextAction.ClearFormatting,
  //   icon: <CreateOutlined />,
  //   label: "Clear Formatting",
  // },
  // {
  //   id: RichTextAction.Quote,
  //   icon: <FormatQuote />,
  //   label: "Quote",
  // },

  // { id: RichTextAction.Divider, icon: <HorizontalRule /> },
  {
    id: RichTextAction.LeftAlign,
    icon: <FormatAlignLeft />,
    label: "Align Left",
  },
  {
    id: RichTextAction.CenterAlign,
    icon: <FormatAlignCenter />,
    label: "Align Center",
  },
  {
    id: RichTextAction.RightAlign,
    icon: <FormatAlignRight />,
    label: "Align Right",
  },
  {
    id: RichTextAction.JustifyAlign,
    icon: <FormatAlignJustify />,
    label: "Justify",
  },
  {
    id: RichTextAction.DecreaseIndent,
    icon: <FormatIndentDecreaseIcon />,
    label: "Decrease Indent",
  },
  {
    id: RichTextAction.IncreaseIndent,
    icon: <FormatIndentIncreaseIcon />,
    label: "Increase Indent",
  },

  // { id: RichTextAction.Divider, icon: <HorizontalRule /> },
  // {
  //   id: RichTextAction.Link,
  //   icon: <InsertLink />,
  //   label: "Insert Link",
  // },

  // {
  //   id: RichTextAction.Table,
  //   icon: <TableChart />,
  //   label: "Insert Table",
  // },
  // {
  //   id: RichTextAction.Image,
  //   icon: <Image />,
  //   label: "Insert Image",
  // },
  // {
  //   id: RichTextAction.HorizontalRule,
  //   icon: <HorizontalRule />,
  //   label: "Horizontal Rule",
  // },
];

export const RICH_TEXT_OPTIONS_SECOND_ROW = [
  {
    id: RichTextAction.Link,
    icon: <InsertLink />,
    label: "Insert Link",
  },

  {
    id: RichTextAction.Table,
    icon: <TableChartOutlinedIcon />,
    label: "Insert Table",
  },
  {
    id: RichTextAction.Image,
    icon: <QrCodeIcon />,
    label: "Insert Image/QR Code",
  },
  {
    id: RichTextAction.HorizontalRule,
    icon: <HorizontalRule />,
    label: "Horizontal Rule",
  },
  // {
  //   id: RichTextAction.Code,
  //   icon: <Code />,
  //   label: "Code",
  // },
  {
    id: RichTextAction.Strikethrough,
    icon: <StrikethroughSIcon />,
    label: "Strikethrough",
  },
  {
    id: RichTextAction.ClearFormat,
    icon: <FormatClearIcon />,
    label: "Clear Formatting",
  },
];

export const LOW_PRIORIRTY = 1;
export const HEADINGS = ["paragraph", "h1", "h2", "h3", "h4", "h5", "h6"];

export const FONT_FAMILY_OPTIONS = [
  "Arial",
  "Courier New",
  "Georgia",
  "Times New Roman",
  "Trebuchet MS",
  "Verdana",
];

export const GROUPS = [
  "Contact Fields",
  "My Information",
  "Dates",
  "Special Fields",
];
export const AVAILABLE_MERGE_FIELDS = [
  //contact fields
  { key: "FirstName", label: "First Name", group: "Contact Fields" },
  { key: "LastName", label: "Last Name", group: "Contact Fields" },
  { key: "Email", label: "Email", group: "Contact Fields" },
  { key: "Company", label: "Company", group: "Contact Fields" },
  { key: "FullName", label: "Full Name", group: "Contact Fields" },
  { key: "Birthday", label: "Birthday", group: "Contact Fields" },
  { key: "StreetAddress", label: "Street Address", group: "Contact Fields" },
  { key: "City", label: "City", group: "Contact Fields" },
  { key: "State", label: "State", group: "Contact Fields" },
  { key: "PostalCode", label: "Postal Code", group: "Contact Fields" },
  { key: "MailingAddress", label: "Mailing Address", group: "Contact Fields" },
  { key: "Phone", label: "Phone", group: "Contact Fields" },
  //My Information
  { key: "mm.FullName", label: "My Full Name", group: "My Information" },
  { key: "mm.Company", label: "My Company", group: "My Information" },
  { key: "mm.Address", label: "My Address", group: "My Information" },
  {
    key: "mm.CityStateZip",
    label: "My City,State,Postal Code",
    group: "My Information",
  },
  { key: "mm.Phone", label: "My Phone", group: "My Information" },
  { key: "mm.Email", label: "My Email", group: "My Information" },
  { key: "mm.Website", label: "My Website", group: "My Information" },

  //Dates
  { key: "Date", label: "Date", group: "Dates" },
  {
    key: "MonthName",
    label: "Month Name",
    group: "Dates",
  },
  { key: "Month", label: "Month", group: "Dates" },
  { key: "Day", label: "Day", group: "Dates" },
  { key: "Year", label: "Year", group: "Dates" },

  // Special Fields
  // { key: "Date", label: "Date", group: "Special Fields" },
  { key: "Header", label: "Header", group: "Special Fields" },
  { key: "Footer", label: "Footer", group: "Special Fields" },
  // Add more as needed
];

export const VALID_MERGE_FIELD_KEYS = new Set(AVAILABLE_MERGE_FIELDS.map(f => f.key));